/** Static “Your Success Roadmap” — matches `/home1` source of truth. */
export type MarketingSuccessRoadmapIcon =
  | 'search'
  | 'file-text'
  | 'graduation-cap'
  | 'stamp'
  | 'plane';

export type MarketingSuccessRoadmapStep = {
  icon: MarketingSuccessRoadmapIcon;
  title: string;
  description: string;
};

export const MARKETING_SUCCESS_ROADMAP_HEADING = {
  title: 'Your Success Roadmap',
  subtitle:
    'A clear, five-step process from your first counseling call to landing at your campus abroad.',
} as const;

export const MARKETING_SUCCESS_ROADMAP_STEPS: MarketingSuccessRoadmapStep[] = [
  { icon: 'search', title: 'Counseling', description: 'Discovery session and profile review' },
  { icon: 'file-text', title: 'Applications', description: 'Shortlist + SOP + recommendations' },
  { icon: 'graduation-cap', title: 'Admissions', description: 'Offer letter & scholarship negotiation' },
  { icon: 'stamp', title: 'Visa', description: 'Documentation & mock interviews' },
  { icon: 'plane', title: 'Departure', description: 'Pre-departure orientation & onboarding' },
];
